import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dt__map-dataContainer-search" }
const _hoisted_2 = {
  key: 0,
  class: "dt__map-dataContainer-head"
}
const _hoisted_3 = { class: "dt__map-dataContainer-head-count" }
const _hoisted_4 = { class: "dt__map-dataContainer-content" }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_search = _resolveComponent("page-search")!
  const _component_sort_component = _resolveComponent("sort-component")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_page_search, {
        objects: this.category.pages,
        placeholder: 'Поиск по названию разделов',
        onOpenSearch: $options.onOpenSearch
      }, null, 8 /* PROPS */, ["objects", "onOpenSearch"])
    ]),
    (this.category.pages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, "Всего " + _toDisplayString(this.category.pages.length), 1 /* TEXT */),
          _createVNode(_component_sort_component, {
            list: this.category.allowedSortModes,
            modelValue: $props.category.sortMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($props.category.sortMode) = $event)),
            "desktop-hidden": true
          }, null, 8 /* PROPS */, ["list", "modelValue"])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.category.pages, (page) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: page.getMapUrl(),
          class: "dt__map-dataContainer-content-sectionItem"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              innerHTML: page.icon,
              class: "dt__map-dataContainer-content-sectionItem-icon"
            }, null, 8 /* PROPS */, _hoisted_5),
            _createTextVNode(" " + _toDisplayString(page.name.name), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}